<template>
    <v-card
        class="fill-height"
        :class="$vuetify.theme.dark ? 'primary' : 'white'"
        style="border-radius: 15px;"
    >
        <v-card-text>
            <div
                class="d-flex"
            >
                <div
                    class="mr-3"
                >
                    <v-icon
                        :color="$vuetify.theme.dark ? 'white' : 'primary'"
                        size="60"
                    >
                        {{ info.icon }}
                    </v-icon>
                </div>
                <div>
                    <div
                        class="d-flex align-end"
                    >
                        <h3
                            class="display-1 mr-2 font-weight-bold"
                            :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                        >
                            {{ info.value }}
                        </h3>
<!--                        <p-->
<!--                            class="d-flex caption align-center mb-0"-->
<!--                            :class="info.positive ? 'green&#45;&#45;text' : 'red&#45;&#45;text'"-->
<!--                        >-->
<!--                            <v-icon-->
<!--                                small-->
<!--                                :color="info.positive ? 'green' : 'red'"-->
<!--                            >-->
<!--                                {{ info.positive ? '$mdiArrowUp' : '$mdiArrowDown' }}-->
<!--                            </v-icon>-->
<!--                            {{ calculatedPercentage }}-->
<!--                        </p>-->
                    </div>
                    <p
                        class="mb-0 accent--text font-weight-bold"
                    >
                        {{ info.description }}
                    </p>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "Icon-Card",

        props: {
            'info': {
                type: Object,
                required: true,
            },
            'loading': {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {}
        },

        computed: {
            calculatedPercentage() {
                let percentage = '';

                percentage += this.info.positive ? '+' : '-';
                percentage += this.info.percentage + '%';
                percentage += ' ' + this.info.percentage_suffix;

                return percentage;
            }
        }
    }
</script>
